<template>
  <input
    ref="inputRef"
    type="text"
    class="ci !text-DataSize !font-DataWeight !text-data-color"
    :style="{ textAlign: inputTextAlignments }"
  />
</template>

<script>
  import { watch, computed } from '@vue/composition-api';
  import { useCurrencyInput } from 'vue-currency-input';

  export default {
    name: 'templates-formComponentsExecute-CurrencyInput',
    props: {
      modelValue: Number, // Vue 2: value
      options: Object,
      inputTextAlignments: String,
    },

    data() {
      return {
        inputTextAlignmentValue: 'left',
      };
    },
    setup(props) {
      const { inputRef, setOptions, setValue } = useCurrencyInput(props.options);

      const inputTextAlignment = computed(() => {
        return props.inputTextAlignments || 'left'; // Set a default value if not provided
      });

      watch(
        () => props.modelValue, // Vue 2: props.value
        (value) => {
          setValue(value);
        }
      );

      watch(
        () => props.options,
        (options) => {
          setOptions(options);
        }
      );

      return { inputRef, inputTextAlignment };
    },
    watch: {
      'data.styles.inputTextAlignments': {
        handler(newVal) {
          // Whenever inputTextAlignments changes, update the computed property.
          this.inputTextAlignmentValue = newVal;
        },
        immediate: true, // This will trigger the handler immediately when the component is created
      },
    },
  };
</script>

<style lang="scss">
  input {
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    line-height: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    appearance: auto;
    -webkit-rtl-ordering: logical;
    cursor: text;
    background-color: -internal-light-dark(rgb(255, 255, 255), rgb(59, 59, 59));
    margin: 0em;
    padding: 1px 2px;
  }

  .ci {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 32px !important;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }
</style>
